<template>
  <div>
    <Breadcrumbs :items="items" />

    <v-slide-x-transition>
      <v-sheet v-show="!detailDialog &&!newQaDialog" class="transparent-background-color fill-content-height">
        <v-row dense class="ma-4">
          <v-col cols="12" sm="12" md="12" align-self="center">
            <v-row dense align="center">
              <v-spacer />
              <v-btn
                small
                color="primary"
                @click.stop="
                newQaDialog = true;
                qaItem='new';"
                class="ms-1"
              >
                <v-icon x-small class="pe-1">fa-plus</v-icon>
                {{ $t("CRUD.newInfo", [$t("AccountQacenter.ObjectName")]) }}
              </v-btn>
            </v-row>
          </v-col>
        </v-row>

        <!-- 表格 -->
        <div class="mx-4 my-4">
          <v-data-table
            :headers="headers"
            :items="account_qacenter"
            :loading="loading"
            multi-sort
            class="elevation-1 px-4 pt-1"
            disable-pagination
            hide-default-footer
          >
            <template v-slot:header.actions="{ header }">
              {{ header.text }}
              <v-icon x-small>fa-sliders-h</v-icon>
            </template>

            <template v-slot:item.actions="{ item }">
              <v-btn
                      small
                      dark
                      color="info"
                      class="px-2 me-2 mb-1"
                      @click.stop="
                      detailDialog = true;
                      detailItem = item;"
              >
                {{ $t("AccountQacenter.Fields.detail") }}
              </v-btn>
            </template>
          </v-data-table>
        </div>
      </v-sheet>
    </v-slide-x-transition>
    <DetailDialog
            v-show="detailDialog"
            v-model="detailItem"
            :accountUserName = "accountUserName"
            :accountInfo = "accountInfo"
            :mode="detailDialog"
            @mode="detailDialog = $event"
            @save="getAccountQacenterFromAPI()"
    />
    <NewQaDialog
            v-show="newQaDialog"
            v-model="qaItem"
            :accountUser = "accountUser"
            :accountInfo = "accountInfo"
            :mode="newQaDialog"
            @mode="newQaDialog = $event"
            @save="getAccountQacenterFromAPI()"
    />
  </div>
</template>
<script>
import { mapState } from "vuex";
import i18n from "@/i18n";
import Breadcrumbs from "@/components/Breadcrumbs";
import AccountQacenter from "@/api/account_qacenter";
import DetailDialog from "./plugins/Detail"
import NewQaDialog from "./plugins/NewQa"

export default {
  components: {
    DetailDialog,
    Breadcrumbs,
    NewQaDialog
  },

  computed: {
    items: () => [
      {
        text: i18n.t("SettingNav.home"),
        disabled: false,
        href: "/home",
      },
      {
        text: i18n.t("App.accountQacenter"),
        disabled: true,
        href: "/account-qacenter",
      },
    ],
    headers: () => [
      {
        text: i18n.t("AccountQacenter.Fields.created"),
        align: "start",
        sortable: false,
        value: "created",
      },
      {
        text: i18n.t("AccountQacenter.Fields.question_code"),
        align: "center",
        sortable: false,
        value: "question_code",
      },
      {
        text: i18n.t("AccountQacenter.Fields.status"),
        align: "center",
        sortable: false,
        value: "status_str",
      },
      {
        text: i18n.t("AccountQacenter.Fields.title"),
        align: "center",
        sortable: false,
        value: "short_title",
      },
      {
        text: i18n.t("AccountQacenter.Fields.last_answer_content"),
        align: "center",
        sortable: false,
        value: "last_answer_content",
      },
      {
        text: i18n.t("TableHeaders.actions"),
        align: "start",
        sortable: false,
        value: "actions",
      },
    ],
    accountID() {
      return this.accountInfo ? this.accountInfo.account_id : "";
    },
    accountUserName() {
      return this.accountUser ? this.accountUser.name : "";
    },
    ...mapState(["loading", "accountInfo", "accountUser"]),
  },

  data: () => ({
    newQaDialog: false,
    detailDialog: false,
    qaItem: '',
    detailItem: [],
    account_qacenter: [],
    deleteDialog: false,
  }),

  mounted() {
    this.getAccountQacenterFromAPI();
  },

  methods: {
    getAccountQacenterFromAPI() {
      if (this.accountID != '') {
        AccountQacenter.fetchList({account_id: this.accountID}).then(
                function (response) {
                  if (response.data.status.isOK()) {
                    this.account_qacenter = response.data.data;
                  }
                }.bind(this)
        );
      }
    }
  },

  watch: {
    $route() {
      if (!this.$route.query.id) {
        this.newQaDialog = false;
        this.detailDialog = false;
      }
    },
    accountID() {
      this.getAccountQacenterFromAPI();
    },
    newQaDialog() {
      if (!this.newQaDialog) {
        this.getAccountQacenterFromAPI();
      }
    },
    detailDialog() {
      if (!this.detailDialog) {
        this.getAccountQacenterFromAPI();
      }
    }
  },
};
</script>